"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientReportStatus = exports.PrescriptionType = void 0;
var PrescriptionType;
(function (PrescriptionType) {
    PrescriptionType[PrescriptionType["Active"] = 0] = "Active";
    PrescriptionType[PrescriptionType["Expired"] = 1] = "Expired";
    PrescriptionType[PrescriptionType["Requested"] = 2] = "Requested";
})(PrescriptionType || (exports.PrescriptionType = PrescriptionType = {}));
var PatientReportStatus;
(function (PatientReportStatus) {
    PatientReportStatus[PatientReportStatus["Error"] = 0] = "Error";
    PatientReportStatus[PatientReportStatus["Success"] = 1] = "Success";
    PatientReportStatus[PatientReportStatus["NoPrescriptions"] = 2] = "NoPrescriptions";
})(PatientReportStatus || (exports.PatientReportStatus = PatientReportStatus = {}));
//# sourceMappingURL=prescription.js.map